import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { useBrowserPool } from '@/hooks/useAdminMonitoring';
import { Skeleton } from '@/components/ui/Skeleton';
import { formatDuration, formatBytes } from '@/utils/formatters';

export function BrowserPoolStatus() {
  const { data, isLoading } = useBrowserPool();
  // Service returns BrowserInstance[] directly
  const instances = data || [];

  return (
    <Card>
      <CardHeader title="Pool Puppeteer" description={`${instances.length} instance(s)`} />
      <CardContent>
        {isLoading ? (
          <div className="space-y-2"><Skeleton className="h-8" /><Skeleton className="h-8" /></div>
        ) : instances.length === 0 ? (
          <p className="text-sm text-neutral-500">Aucune instance active</p>
        ) : (
          <div className="space-y-2">
            {instances.map((inst) => (
              <div key={inst.id} className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3 text-sm">
                <div>
                  <span className="text-neutral-700 dark:text-neutral-300">#{inst.id.slice(0, 8)}</span>
                  {inst.currentTask && <span className="ml-2 text-xs text-neutral-500">{inst.currentTask}</span>}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-neutral-500">{formatBytes(inst.memoryUsage)} - {formatDuration(inst.uptime)}</span>
                  <Badge variant={inst.status === 'idle' ? 'neutral' : inst.status === 'busy' ? 'warning' : 'success'}>
                    {inst.status}
                  </Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
